export default __webpack_public_path__ + "static/media/bathroom-mid.71e08432.jpg";